import * as React from "react";
const Submitbtn = (props) => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.29602 3.40591C3.91012 2.30472 1.36183 4.58555 2.19279 7.07847L3.45424 10.8195C3.59136 11.2262 3.97267 11.5 4.40182 11.5H13C13.5523 11.5 14 11.9478 14 12.5C14 13.0523 13.5523 13.5 13 13.5H4.40182C3.97267 13.5 3.59136 13.7739 3.45424 14.1805L2.19281 17.9216C1.36183 20.4145 3.91012 22.6954 6.29603 21.5942L20.0983 15.2239C22.422 14.1514 22.422 10.8487 20.0983 9.77619L6.29602 3.40591Z"
      fill="#FCFCFD"
    />
  </svg>
);
export default Submitbtn;
